// Tiny hash router. Routes are `#/<moduleId>`. Renders the active module into
// the content area and keeps the sidebar + topbar in sync.
import { MODULES, moduleById } from '../modules/registry.js'

export function currentId() {
  return (location.hash.replace(/^#\/?/, '').split('/')[0]) || 'overview'
}

export function startRouter({ content, topTitle, topSub, onChange }) {
  function render() {
    const m = moduleById(currentId())
    topTitle.textContent = m.title
    topSub.textContent = m.sub
    content.innerHTML = ''
    m.render(content)
    document.querySelectorAll('.nav a.item').forEach(a => {
      a.classList.toggle('active', a.dataset.id === m.id)
    })
    if (onChange) onChange(m)
    content.parentElement?.scrollTo?.(0, 0)
  }
  window.addEventListener('hashchange', render)
  if (!location.hash) location.replace('#/overview')
  render()
}

export { MODULES }
